import useSWR from "swr";
import { getCacheKeys } from "../components/services/cache-service";
import { UseCacheKeysModel } from "../components/services/cache-types";

const useCacheKeys = (): UseCacheKeysModel => {
  const { data, error, mutate } = useSWR(`/cache/keys`, () => getCacheKeys());

  return {
    data,
    isLoading: !error && !data,
    error,
    mutate,
  };
};

export default useCacheKeys;
